import { usePage } from '@inertiajs/vue3'
import ahoy from '~/config/ahoy'
import type { AnalyticsEventMap, AnalyticsEventName } from '~/types/analytics'
import type { PageProps } from '~/types/inertia'

const SCHEMA_VERSION = 1

type TrackOptions = {
  includeOrganization?: boolean
}

export function useAnalytics() {
  const page = usePage<PageProps>()

  function track<Name extends AnalyticsEventName>(
    name: Name,
    properties: AnalyticsEventMap[Name],
    { includeOrganization = true }: TrackOptions = {}
  ) {
    const user = page.props.currentUser
    if (!user) return

    const organization = page.props.currentOrganization

    ahoy.start()
    ahoy.track(name, {
      ...properties,
      schema_version: SCHEMA_VERSION,
      active_page: page.props.activePage,
      user_role: user.role,
      ...(includeOrganization &&
        organization && {
          organization_id: organization.id,
          organization_demo: organization.demo
        })
    })
  }

  return { track }
}
